export default __webpack_public_path__ + "static/media/login-image.54b7ae25.png";